(function() {
  function initTimelineSlider(sectionId) {
    var section = document.querySelector('[data-timeline-section="' + sectionId + '"]');
    if (!section) return;

    var track = section.querySelector('.timeline-slider__track');
    var prevBtns = Array.from(section.querySelectorAll('.timeline-slider__btn--prev'));
    var nextBtns = Array.from(section.querySelectorAll('.timeline-slider__btn--next'));
    var items = Array.from(section.querySelectorAll('.timeline-slider__item'));

    if (!track || items.length === 0) return;

    var autoplayDesktop = section.dataset.autoplayDesktop === 'true';
    var autoplayMobile = section.dataset.autoplayMobile === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
    var autoplayInterval = null;
    var isHovering = false;
    var currentIndex = 0;

    function getGap() {
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap);
      if (isNaN(gap)) gap = 30;
      return gap;
    }

    function getItemWidth(index) {
      if (items.length === 0) return 0;
      var item = items[index] || items[0];
      return item.offsetWidth;
    }

    function getScrollPositionForIndex(index) {
      if (index <= 0) return 0;
      var position = 0;
      var gap = getGap();
      for (var i = 0; i < index; i++) {
        position += getItemWidth(i) + gap;
      }
      return position;
    }

    function getMaxScrollPosition() {
      if (items.length === 0) return 0;
      var lastItem = items[items.length - 1];
      var lastItemLeft = lastItem.offsetLeft - track.offsetLeft;
      var lastItemWidth = lastItem.offsetWidth;
      var trackWidth = track.clientWidth;
      var centerOffset = (trackWidth / 2) - (lastItemWidth / 2);
      return Math.max(0, lastItemLeft - centerOffset);
    }

    function updateButtonStates() {
      var isPrevDisabled = currentIndex <= 0;
      var isNextDisabled = currentIndex >= items.length - 1;
      prevBtns.forEach(function(btn) { btn.disabled = isPrevDisabled; });
      nextBtns.forEach(function(btn) { btn.disabled = isNextDisabled; });
    }

    function updateActiveItem() {
      items.forEach(function(item, i) {
        item.classList.toggle('is-active', i === currentIndex);
      });
    }

    function scrollToIndex(index) {
      if (index < 0) index = 0;
      if (index >= items.length) index = items.length - 1;
      currentIndex = index;

      var targetScroll = getScrollPositionForIndex(index);
      var maxScroll = getMaxScrollPosition();

      if (targetScroll > maxScroll) {
        targetScroll = maxScroll;
      }

      track.scrollTo({ left: targetScroll, behavior: 'smooth' });
      updateButtonStates();
      updateActiveItem();
    }

    function scrollPrev() {
      scrollToIndex(currentIndex - 1);
    }

    function scrollNext() {
      scrollToIndex(currentIndex + 1);
    }

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function shouldAutoplay() {
      if (isMobile()) {
        return autoplayMobile;
      }
      return autoplayDesktop;
    }

    function startAutoplay() {
      if (autoplayInterval) return;
      if (!shouldAutoplay()) return;

      autoplayInterval = setInterval(function() {
        if (!isHovering) {
          if (currentIndex >= items.length - 1) {
            scrollToIndex(0);
          } else {
            scrollNext();
          }
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    function handleResize() {
      updateButtonStates();
      stopAutoplay();
      startAutoplay();
    }

    function findCurrentIndexFromScroll() {
      var scrollLeft = track.scrollLeft;
      var gap = getGap();
      var accumulatedWidth = 0;

      for (var i = 0; i < items.length; i++) {
        var itemWidth = getItemWidth(i);
        var itemCenter = accumulatedWidth + (itemWidth / 2);

        if (scrollLeft < itemCenter) {
          return i;
        }
        accumulatedWidth += itemWidth + gap;
      }
      return items.length - 1;
    }

    prevBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        scrollPrev();
      });
    });

    nextBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        scrollNext();
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        currentIndex = findCurrentIndexFromScroll();
        updateButtonStates();
        updateActiveItem();
      }, 100);
    });

    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    track.addEventListener('mousedown', function(e) {
      isDragging = true;
      dragMoved = false;
      dragStartX = e.pageX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      stopAutoplay();
    });

    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      var delta = e.pageX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      track.scrollLeft = dragStartScrollLeft - delta;
      e.preventDefault();
    });

    window.addEventListener('mouseup', function() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      currentIndex = findCurrentIndexFromScroll();
      updateButtonStates();
      updateActiveItem();
      startAutoplay();
    });

    track.addEventListener('click', function(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    section.addEventListener('mouseenter', function() {
      isHovering = true;
    });

    section.addEventListener('mouseleave', function() {
      isHovering = false;
    });

    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });

    updateButtonStates();
    updateActiveItem();
    startAutoplay();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function() {
        updateButtonStates();
      });
      ro.observe(track);

      section.addEventListener('shopify:section:unload', function() {
        ro.disconnect();
        stopAutoplay();
      });
    }
  }

  function initAllTimelineSliders() {
    var sections = document.querySelectorAll('[data-timeline-section]');
    sections.forEach(function(section) {
      var sectionId = section.dataset.timelineSection;
      initTimelineSlider(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimelineSliders);
  } else {
    initAllTimelineSliders();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-timeline-section]');
    if (section) {
      var sectionId = section.dataset.timelineSection;
      initTimelineSlider(sectionId);
    }
  });
})();
